import { render, staticRenderFns } from "./giveCouponPop.vue?vue&type=template&id=30b997bd&scoped=true&"
import script from "./giveCouponPop.vue?vue&type=script&lang=js&"
export * from "./giveCouponPop.vue?vue&type=script&lang=js&"
import style0 from "./giveCouponPop.vue?vue&type=style&index=0&id=30b997bd&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b997bd",
  null
  
)

export default component.exports